module.exports = __webpack_public_path__ + "static/img/arrow_left.b593ecf4.svg";